/**
 * Admin display for Her Collection order money state.
 * Payment = historical fact (SIIS never regresses it once paid).
 * Refund = Shopify's current financial_status (authoritative), falling back to SIIS refund totals.
 */
export type RefundState = "none" | "refund_pending" | "partially_refunded" | "refunded" | "cancelled";

export const paymentLabel = (financialStatus: string, paidAt: string | null) =>
  paidAt || ["paid", "partially_refunded", "refunded"].includes(financialStatus)
    ? "Paid"
    : financialStatus === "voided" ? "Voided" : "Pending";

export const refundState = (o: {
  order_status: string;
  shopify_financial_status: string | null;
  merch_refunded_cents: number;
  merch_total_cents: number;
}): RefundState => {
  if (o.order_status === "cancelled") return "cancelled";
  const s = o.shopify_financial_status;
  if (s === "refunded") return "refunded";
  if (s === "partially_refunded") return "partially_refunded";
  // Shopify still reports no refunded money, but refund line items exist (refund transaction not yet settled).
  if (s) return o.merch_refunded_cents > 0 ? "refund_pending" : "none";
  if (o.merch_refunded_cents <= 0) return "none";
  return o.merch_refunded_cents >= o.merch_total_cents ? "refunded" : "partially_refunded";
};

export const REFUND_LABEL: Record<RefundState, string> = {
  none: "No refund",
  refund_pending: "Refund issued — money still pending in Shopify",
  partially_refunded: "Partially refunded",
  refunded: "Fully refunded",
  cancelled: "Cancelled",
};
